import Badge from '@pelckmans/elementis/components/badge';
import Pill from '@pelckmans/elementis/components/pill';
import Results from '@pelckmans/elementis/components/results';
import ChapterIcon from '@pelckmans/elementis/icons/chapter';
import ExerciseIcon from '@pelckmans/elementis/icons/exercise';
import { useTranslation } from 'react-i18next';
import type { ContentTypeSummary } from '../../api/exercise-category';
import { getResultPercentages } from '../../utils/results';

export interface SublevelSummaryProps {
  totalExercises: number;
  completedExercises?: number;
  sublevels?: unknown[];
  contentTypeSummary?: ContentTypeSummary[];
  score?: {
    maximum: number;
    achievable: number;
    achieved: number;
  };
}

/**
 * SublevelSummary Pills for ContentHeaders and Cards in (virtual) exercise modules.
 */
export default function SublevelSummary({
  sublevels,
  totalExercises,
  completedExercises,
  score,
  contentTypeSummary,
}: SublevelSummaryProps) {
  const { t } = useTranslation();

  return (
    <>
      {sublevels && sublevels.length > 0 && (
        <Pill key="sublevel-count" icon={<ChapterIcon data-testid="sublevel-count-icon" />}>
          {t('MODULES.SUBLEVEL_SUMMARY.CATEGORIES_COUNT', {
            count: sublevels.length,
          })}
        </Pill>
      )}
      {totalExercises > 0 && (
        <Pill key="exercises-count" icon={<ExerciseIcon data-testid="exercises-count-icon" />}>
          {t('MODULES.SUBLEVEL_SUMMARY.EXERCISES_COUNT', {
            achieved: completedExercises,
            maximum: totalExercises,
          })}
        </Pill>
      )}

      {contentTypeSummary?.map(ct => (
        <Pill data-testid={'content-type-count-icon-' + ct.id} key={ct.id} badge={<Badge>{ct.usage}</Badge>}>
          {ct.name}
        </Pill>
      ))}
      {score && score.maximum > 0 && (
        <Pill key="results">
          <Results quantifiable responsive={false} {...getResultPercentages(score)} />
        </Pill>
      )}
    </>
  );
}
